import { FC } from 'react'

import TrainingTypeFormFields from './training-type-form-fields'

import { ITrainingTypeFormProps } from './training-type-form-types'

const TrainingTypeForm: FC<ITrainingTypeFormProps> = props => {
  const { handleSubmit, formName, submitting } = props

  return (
    <form onSubmit={handleSubmit} id={formName}>
      <TrainingTypeFormFields disabled={submitting} />
    </form>
  )
}

export default TrainingTypeForm
